module.exports = __webpack_public_path__ + "img/26.3669dce4.svg";